import React from "react"
import Layout from "components/layouts/Layout"
import SEO from "components/elements/seo"
import Sponsors from "components/sections/Sponsors"
import MobileHero from "components/sections/play/mobile/Hero"
import DesktopHero from "components/sections/play/desktop/Hero"
import DesktopStartPlaying from "components/sections/play/desktop/Start-playing"
import MobileStartPlaying from "components/sections/play/mobile/Start-playing"
import Ticker from "components/elements/Ticker"
import { BrowserView, isMobile } from "react-device-detect"
class PlayPage extends React.Component {
  render() {
    return (
      <Layout>
        <SEO
          title="Sixer | Buy and Sell Fantasy Stocks in Cricket Players"
          description="Sixer is a fantasy cricket game where top cricket players are presented as stocks you can buy and sell"
          keywords={[
            "fantasy cricket",
            "fantasy cricket app",
            " cricket stock",
            "fantasy cricket ipl",
            "fantasy ipl",
          ]}
        />

        {isMobile ? <MobileHero /> : <DesktopHero />}
        {isMobile ? <MobileStartPlaying /> : <DesktopStartPlaying />}

        <Sponsors />
        <BrowserView>
          <Ticker />
        </BrowserView>
      </Layout>
    )
  }
}

export default PlayPage
